module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAATUlEQVQ4y83U0QkAIAgE0AMHcKRWb6QGCC4tgprA88v3J4cKPjVQrI5bTUDGbCTkDJFU0InIJOQTuThQ0B7Mv5TKFJOFJhQkdNM6v24BqRqSPyH030IAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDMrMDk6MDB5Ddv1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00076_100x100.png
// module id = 43L0
// module chunks = 0